import { render, staticRenderFns } from "./editHomework.vue?vue&type=template&id=2e4fa95d&scoped=true"
import script from "./editHomework.vue?vue&type=script&lang=js"
export * from "./editHomework.vue?vue&type=script&lang=js"
import style0 from "./editHomework.vue?vue&type=style&index=0&id=2e4fa95d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4fa95d",
  null
  
)

export default component.exports